import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { of, switchMap } from 'rxjs';

import { LoginService } from '../login/login.service';
import { ROUTE_CONSTANTS } from '../../util/route.constants';

export const AuthGuard: CanActivateFn | CanActivateChildFn = () => {
  const router = inject(Router);
  const loginService = inject(LoginService);

  return loginService.isLoggedIn().pipe(
    switchMap((authenticated) => handleAuthentication(authenticated, loginService, router))
  );
};

// Extracted decision logic into its own function
function handleAuthentication(
  authenticated: boolean,
  loginService: LoginService,
  router: Router
) {
  const actionMap = {
    "true": () => handleAuthenticated(loginService),
    "false": () => handleUnauthenticated(router),
  };
  return actionMap[String(authenticated)]?.();
}

function handleAuthenticated(loginService: LoginService) {
  if (!loginService.loggedIn$.value) {
    loginService.loggedIn$.next(true);
  }
  return of(true);
}

function handleUnauthenticated(router: Router) {
  const urlTree = router.parseUrl(`${ROUTE_CONSTANTS.LOGIN}`);
  return of(urlTree);
}
